import {BuyType} from '@/utils/constants/promotionConstants'
import CategoryAndSubCategoryContent from './CategoryAndSubCategoryContent/CategoryAndSubCategoryContent'
import GTINSContent from './GTINSContent/GTINSContent'
import ProductAndBrandContent from './ProductAndBrandContent/ProductAndBrandContent'
import ProductIdContent from './ProductIdContent/ProductIdContent'
import './_selectionModalContent.scss'

const SelectionModalContent = ({type, selectionModalHookValue, isExclude}) => {
  const {activeTabIndex, selectedTags, combination, tabs, onTabChange, getChildList, setSelectedTags, setCombination} =
    selectionModalHookValue

  if (BuyType.CATEGORY === type) {
    return (
      <div className="selection-modal-content min-h-[200px]">
        <CategoryAndSubCategoryContent
          activeTabIndex={activeTabIndex}
          selectedTags={selectedTags}
          combination={combination}
          tabs={tabs}
          onTabChange={onTabChange}
          setSelectedTags={setSelectedTags}
          setCombination={setCombination}
          isExclude={isExclude}
        />
      </div>
    )
  }

  if (type === BuyType.PRODUCT || type === BuyType.BRAND) {
    return (
      <div className="selection-modal-content">
        <ProductAndBrandContent
          activeTabIndex={activeTabIndex}
          selectedTags={selectedTags}
          combination={combination}
          tabs={tabs}
          onTabChange={onTabChange}
          getChildList={getChildList}
          setSelectedTags={setSelectedTags}
          setCombination={setCombination}
          isExclude={isExclude}
        />
      </div>
    )
  }

  if (type === BuyType.GTINS) {
    return (
      <GTINSContent
        onSelection={setSelectedTags}
        setCombination={setCombination}
        selectedGtins={selectedTags.itemType === BuyType.GTINS ? selectedTags.values : []}
        combination={combination}
        isExclude={isExclude}
      />
    )
  }

  if (type === BuyType.PRODUCT_ID) {
    return (
      <div className="selection-modal-content">
        <ProductIdContent
          onSelection={setSelectedTags}
          setCombination={setCombination}
          combination={combination}
          isExclude={isExclude}
          selectedValues={selectedTags.itemType === BuyType.PRODUCT_ID ? selectedTags.values : []}
        />
      </div>
    )
  }
}

export default SelectionModalContent
